import React from "react";
import styles from "./QuestionnareInput.module.scss";

interface QuestionnareInputProps {
  label: string;
  name: string;
  isRequired: boolean;
  isEmail?: boolean;
  isTel?: boolean;
  defaultValue: string;
  onChange: (value: string) => void;
  showErrors?: boolean;
}

const QuestionnareInput: React.FC<QuestionnareInputProps> = ({
  label,
  name,
  isRequired,
  isEmail,
  isTel,
  defaultValue,
  onChange,
  showErrors = false,
}) => {
  const [value, setValue] = React.useState("");
  const [isFocused, setIsFocused] = React.useState(defaultValue !== "");
  const [error, setError] = React.useState("");
  const [touched, setTouched] = React.useState(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const isValidEmail = (email: string) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const isValidTel = (tel: string) => {

    return /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(tel);
  };

  const validate = (value: string) => {
    let errorMessage = "";
    const trimmedValue = value.trim();

    if (isRequired && trimmedValue === "") {
      errorMessage = "Это поле обязательно для заполнения";
    } else if (isEmail && trimmedValue !== "" && !isValidEmail(trimmedValue)) {
      errorMessage = "Введите корректный email адрес";
    } else if (isTel && trimmedValue !== "" && !isValidTel(trimmedValue)) {
      errorMessage = "Введите корректный номер телефона";
    }

    setError(errorMessage);
    return errorMessage === "";
  };

  React.useEffect(() => {
    if (showErrors || touched) {
      validate(value);
    }
  }, [showErrors, touched, value]);

  React.useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange?.(newValue);
  };

  const handleBlur = () => {
    setTouched(true);
    validate(value);
    setIsFocused(value !== "");
  };

  return (
    <div className={styles.inputWrapper} ref={wrapperRef}>
      <label className={isFocused ? `${styles.label} ${styles.active}` : styles.label} htmlFor={name}>
        {label} {isRequired && <span>*</span>}
      </label>
      <input
        type={isEmail ? "email" : isTel ? "tel" : "text"}
        id={name}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={() => setIsFocused(true)}
        className={`${styles.input} ${error && (showErrors || touched) ? styles.invalid : ""}`}
        required={isRequired}
      />
      {(showErrors || touched) && error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

export default QuestionnareInput;
